import apiService from "../../services/api.service";
import events from "../../configs/eventsconfig.json";

export default {
  install(Vue) {
    Vue.prototype.$api = apiService;
  }
};
